import axios from "axios";

export const getValuationSuggestions = (organizationId, lng = "fr") => {
  const requestUrl = `/team/valuations`;

  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      lng: lng.charAt(0).toUpperCase() + lng.slice(1)
    }
  });
};

export const saveValuationSettings = ({ organization, labels }) => {
  const requestUrl = `/team/valuations/add`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("coefficient", parseFloat(labels.coefficient));
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);

  return axios.post(requestUrl, formData);
};

export const updateValuationSettings = ({ organization, id, labels }) => {
  const requestUrl = `/team/valuations/edit-name`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("id", id);
  formData.append("coefficient", parseFloat(labels.coefficient));
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);
  formData.append("valuations", labels.valuations);

  return axios.post(requestUrl, formData);
};

export const deleteValuationSettings = ({ organization, isForced, id }) => {
  const requestUrl = `/team/valuations/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("isForced", isForced);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/valuation.js